import React from 'react';

export const Icon = (props: any) => {
  return (
    <svg x="0px" y="0px" viewBox="0 0 19 9" {...props}>
      <g>
        <path
          d="M17.3,1h-2.8C14.2,1,14,0.8,14,0.5S14.2,0,14.5,0h4C18.8,0,19,0.2,19,0.5v4C19,4.8,18.8,5,18.5,5S18,4.8,18,4.5V1.7
l-6.1,6.1c-0.2,0.2-0.5,0.2-0.7,0L6.5,3.2L0.9,8.9C0.7,9,0.3,9,0.1,8.9C0,8.7,0,8.3,0.1,8.1l6-6C6.3,2,6.7,2,6.9,2.1l4.6,4.6
L17.3,1z"
        />
      </g>
    </svg>
  );
};
